import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { computed } from "vue";
export function useHorsePonyTypesHelper() {
    function getPonyTypes() {
        var _a, _b;
        return ((_b = (_a = apolloClient.readQuery({
            query: gql `
          query MasterPonyTypes {
            ponyTypes
          }
        `
        })) === null || _a === void 0 ? void 0 : _a.ponyTypes) !== null && _b !== void 0 ? _b : []);
    }
    const horsePonyTypes = computed(() => getPonyTypes());
    return {
        horsePonyTypes
    };
}
